module.exports = __webpack_public_path__ + "static/media/r2.acb2533d.jpg";